/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDataPDF, IDataVoucherSuccessComponent } from '@pacifico/interfaces/components.interface';
import { IRequestSendEmail } from '@pacifico/interfaces/shared-api.interface';
import { SharedApiService } from '@pacifico/services/api/shared/shared-api.service';
import { AlertService } from '@pacifico/services/local/alert.service';
import { IImg, PdfMakeWrapper, Table, Txt } from 'pdfmake-wrapper';
import * as pdfFonts from 'pdfmake/build/vfs_fonts'; // fonts provided for pdfmake
import * as logo_pc from './logoBase64.js';

@Component({
	selector: 'app-voucher-success',
	templateUrl: './voucher-success.component.html',
	styleUrls: ['./voucher-success.component.scss']
})
export class VoucherSuccessComponent {
	@Input() dataVoucher!: IDataVoucherSuccessComponent;
	@Input() dataPdf!: IDataPDF;
	@Input() dataEmail: IRequestSendEmail | undefined;
	@Input() type = 'transfer';
	@Input() classOperations = '';
	@Input() showSendEmailOption = true;

	constructor(
		private _datePipe: DatePipe,
		private _formBuilder: FormBuilder,
		private _sharedApiService: SharedApiService,
		private _alertService: AlertService
	) {
		this._formEmail();
	}

	private _colorPacifico = '#004687';
	showSendEmail = false;
	formGroup!: FormGroup;

	clickPrint(): void {
		this._generatePdf(true);
	}

	clickSavePdf(): void {
		this._generatePdf(false);
	}

	clickShowSendEmail(): void {
		this.showSendEmail = !this.showSendEmail;
	}

	clickSendEmail(): void {
		if (this.formGroup.valid && this.dataEmail) {
			this.dataEmail.emailcc = this.emailField.value as string;
			this._sharedApiService.sendEmail(this.dataEmail).subscribe((response) => {
				if (response && response.status.code === '0000') {
					this._alertService.showInfo('¡El email se envió correctamente!');
				} else {
					this._alertService.showError('Ocurrio un error inesperado, vuelva a intentar');
				}
			});
		}
	}

	private _generatePdf(print: boolean): void {
		PdfMakeWrapper.setFonts(pdfFonts);
		const pdf = new PdfMakeWrapper();
		pdf.defaultStyle({
			fontSize: 11
		});

		pdf.pageOrientation('portrait');
		pdf.pageSize('A4');
		pdf.pageMargins([20, 40, 20, 40]);

		const dateNow = new Date();

		const dateNowText = new Txt(`${this._datePipe.transform(dateNow, 'dd/MM/YYYY hh:mm a')!}`)
			.margin([20, 5, 0, 0])
			.fontSize(10).end;

		pdf.header(dateNowText);

		const logo: IImg = { image: logo_pc.logoBase64, fit: [150, 150] };
		pdf.add(logo);
		pdf.add(pdf.ln(2));
		pdf.add(new Txt('Agencia Virtual Cooperativa Pacífico').alignment('center').color(this._colorPacifico).bold().end);
		pdf.add(new Txt(this.dataPdf.title).alignment('center').color(this._colorPacifico).bold().end);
		pdf.add(pdf.ln(4));
		pdf.add(new Txt(this.dataPdf.subTitle).fontSize(12).color(this._colorPacifico).bold().end);
		pdf.add(pdf.ln(2));

		const table = this._getTable(this.type);

		pdf.add(table);

		pdf.info({ title: this.dataPdf.title });
		if (print) {
			pdf.create().print();
		} else {
			pdf.create().download(this.dataPdf.title);
		}
	}

	private _getTable(type: string) {
		if (type === 'transfer') {
			let data: any[][] = [];

			if (this.dataPdf.data) {
				data = this.dataPdf.data.map((item) => {
					return [new Txt(item.key).color(this._colorPacifico).bold().end, new Txt(item.value).bold().end];
				});
			} else {
				if (this.dataPdf.headline) {
					data.push([
						new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
						new Txt(this.dataPdf.headline).bold().end
					]);
				}

				if (this.dataPdf.numberOperation) {
					data.push([
						new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
						new Txt(this.dataPdf.numberOperation).bold().end
					]);
				}

				data = data.concat(this._getDataTransfer());
			}

			return new Table(data).widths(['30%', 'auto']).layout('noBorders').fontSize(12).end;
		} else if (type === 'token_digital') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('TOKEN DIGITAL:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.medioPreferidoToken).bold().end
				],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'update_email') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('NUEVO CORREO ELECTRONICO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.nuevoCorreoElectronico).bold().end
				],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'update_phone') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('NUEVO TELEFONO REGISTRADO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.nuevoTelefono).bold().end
				],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'update_limits') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('NUEVO LÍMITE DIARIO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.nuevoLimiteOperaciones).bold().end
				],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'loans_online') {
			const data: unknown[][] = [];
			data.push(
				[
					new Txt('CÓDIGO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[new Txt('MONTO DEL PRÉSTAMO:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.amount).bold().end],
				[new Txt('CUOTA MENSUAL:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.feeAmount!).bold().end],
				[
					new Txt('NÚMERO DE CUOTAS:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.feeNumber!).bold().end
				],
				[new Txt('DÍA DE PAGO:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.payDay!).bold().end],
				[new Txt('CUENTAS EN GARANTÍA').color(this._colorPacifico).bold().end, new Txt('').bold().end]
			);

			if (this.dataPdf.accounts && this.dataPdf.accounts.length > 0) {
				this.dataPdf.accounts.forEach((account) => {
					data.push([
						new Txt(account.title).color(this._colorPacifico).bold().end,
						new Txt(account.subTitle).bold().end
					]);
				});
			}

			data.push(
				[
					new Txt('CUENTA DESEMBOLSO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.destinationAccount).bold().end
				],
				[new Txt('DESCRIPCIÓN:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.description!).bold().end],
				[
					new Txt('Nº DE SOLICITUD:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numRequest!).bold().end
				],
				[new Txt('FECHA Y HORA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			);

			return new Table(data).widths(['30%', 'auto']).layout('noBorders').fontSize(12).end;
		} else if (type === 'update_card') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('BLOQUEO TEMPORAL:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.bloqueoTemporal).bold().end
				],
				[
					new Txt('COMPRAS POR INTERNET:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.comprasInternet).bold().end
				],
				[
					new Txt('COMPRAS EN EL EXTRANJERO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.comprasExtranjero).bold().end
				],
				[
					new Txt('AVISOS Y ALERTAS:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.warningAlerts).bold().end
				],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'block_card') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[new Txt('TIPO DE OPERACIÓN:').color(this._colorPacifico).bold().end, new Txt('BLOQUEO DEFINITIVO').bold().end],
				[
					new Txt('NUMERO DE TARJETA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.cardNumber).bold().end
				],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'loans_cancellation') {
			const table: any[][] = [
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[new Txt('PRÉSTAMO:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.feeNumber!).bold().end],
				[
					new Txt('CAPITAL:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.mountSolesDolares!).bold().end
				],
				[new Txt('INTERÉS:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.feeAmount!).bold().end],
				[new Txt('MORA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.monetaryDefault!).bold().end],
				[new Txt('GASTOS:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.expenses!).bold().end],
				[new Txt('TOTAL:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.total!).bold().end],
				[new Txt('CUENTA CARGO:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.originAccount).bold().end]
			];

			if (this.dataPdf.typeChange) {
				table.push([
					new Txt('TIPO DE CAMBIO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.typeChange).bold().end
				]);

				table.push([
					new Txt('IMPORTE:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.amount).bold().end
				]);
			}
			return new Table(table).widths(['30%', 'auto']).layout('noBorders').fontSize(12).end;
		} else if (type === 'exchange_rate') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('TIPO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.operationType!).bold().end
				],
				[
					new Txt('IMPORTE A OBTENER:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.mountSolesDolares!).bold().end
				],
				[
					new Txt('RESULTADO CAMBIO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.exchangeResult!).bold().end
				],
				[
					new Txt('TIPO DE CAMBIO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.exchangeRate!).bold().end
				],
				[
					new Txt('CUENTA DE ORIGEN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.originAccount).bold().end
				],
				[
					new Txt('CUENTA DE DESTINO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.destinationAccount).bold().end
				]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'cancellation_savings') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('TIPO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.operationType!).bold().end
				],
				[
					new Txt('NÚMERO DE CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.originAccount).bold().end
				],
				[new Txt('TOTAL PAGADO:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.amount).bold().end],
				[
					new Txt('CUENTA DE DESTINO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.destinationAccount).bold().end
				]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'payment-schedule-saving') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('TIPO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.operationType!).bold().end
				],
				[
					new Txt('NÚMERO DE CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.originAccount).bold().end
				],
				[new Txt('IMPORTE CARGADO:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.amount).bold().end],
				[
					new Txt('NÚMERO DE CUOTAS PAGADAS:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.feeNumber!).bold().end
				],
				[
					new Txt('DÉBITO AUTOMÁTICO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.automaticDebit!).bold().end
				]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'fixed-term-cancellation') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('NRO DE CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.originAccount).bold().end
				],
				[new Txt('MONEDA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.money!).bold().end],
				[
					new Txt('IMPORTE DE APERTURA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.openingAmount!).bold().end
				],
				[
					new Txt('INTERÉS GANADO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.interestGain!).bold().end
				],
				[
					new Txt('OTROS ABONOS:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.othersSaving!).bold().end
				],
				[
					new Txt('INTERÉS PAGADO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.interestPaid!).bold().end
				],
				[new Txt('NETO A PAGAR:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.amount).bold().end],
				[
					new Txt('REGALO / COMISIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.giftCommission!).bold().end
				],
				[
					new Txt('CUENTA DESTINO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.destinationAccount).bold().end
				],
				[
					new Txt('MONEDA CTA. DESTINO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.destinationMoney!).bold().end
				],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'fixed-term-interest-charge') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('NRO DE CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.originAccount).bold().end
				],
				[new Txt('MONEDA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.money!).bold().end],
				[
					new Txt('SALDO A LA FECHA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.balanceAccount!).bold().end
				],
				[new Txt('INTERÉS DISPONIBLE:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.rate!).bold().end],
				[new Txt('IMPORTE A RETIRAR:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.amount).bold().end],
				[
					new Txt('CUENTA DESTINO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.destinationAccount).bold().end
				],
				[
					new Txt('MONEDA CTA. DESTINO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.destinationMoney!).bold().end
				],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'open-fixed-term') {
			const table: any[][] = [
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.newAccountNumber!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('CUENTA DE ORIGEN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.originAccount).bold().end
				],
				[new Txt('MONEDA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.money!).bold().end],
				[new Txt('IMPORTE:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.amount).bold().end],
				[
					new Txt('NOMBRE DEL DEPÓSITO').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.description!).bold().end
				],
				[new Txt('PLAZO DÍAS').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.term!).bold().end],
				[new Txt('TASA ANUAL').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.rate!).bold().end]
			];

			if (this.dataPdf.methodPayment) {
				table.push(
					[
						new Txt('MODALIDAD DE PAGO:').color(this._colorPacifico).bold().end,
						new Txt(this.dataPdf.methodPayment).bold().end
					],
					[
						new Txt('CUENTA ABONO DE INT. AUTOMÁTICO:').color(this._colorPacifico).bold().end,
						new Txt(this.dataPdf.destinationAccount).bold().end
					]
				);
				if (this.dataPdf.typeChange) {
					table.push([
						new Txt('TIPO DE CAMBIO:').color(this._colorPacifico).bold().end,
						new Txt(this.dataPdf.typeChange).bold().end
					]);
				}
			}
			table.push([new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]);
			return new Table(table).widths(['30%', 'auto']).layout('noBorders').fontSize(12).end;
		} else if (type === 'savings') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('TIPO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.operationType!).bold().end
				],
				[
					new Txt('NRO DE CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.originAccount).bold().end
				],
				[new Txt('MONEDA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.money!).bold().end],
				[new Txt('TASA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.feeNumber!).bold().end],
				// [new Txt('TITULAR:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.headline!).bold().end],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'schedulled_savings') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('TIPO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.operationType!).bold().end
				],
				[
					new Txt('NRO DE CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.originAccount).bold().end
				],
				[new Txt('CUOTA MENSUAL:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.feeAmount!).bold().end],
				[new Txt('TASA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.rate!).bold().end],
				[new Txt('PLAZO:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.term!).bold().end],
				[
					new Txt('DEBITO AUTOMATICO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.automaticDebit!).bold().end
				],

				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'service-pay') {
			const table: any[][] = [];

			table.push([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[new Txt('CATEGORIA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.category!).bold().end],
				[new Txt('EMPRESA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.company!).bold().end]
			]);
			if (this.dataPdf.service) {
				table.push([
					new Txt('SERVICIO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.service).bold().end
				]);
				this.dataPdf.data?.forEach((data) => {
					table.push([
						new Txt(data.key.toUpperCase() + ':').color(this._colorPacifico).bold().end,
						new Txt(data.value).bold().end
					]);
				});
			}

			table.push([
				[
					new Txt('NOMBRE DE CLIENTE:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('CUENTA DE ORIGEN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.originAccount).bold().end
				]
			]);

			return table;
		} else if (type === 'savings_schedulled') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('TIPO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.operationType!).bold().end
				],
				[
					new Txt('NRO DE CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.newAccountNumber!).bold().end
				],
				[new Txt('CUOTA MENSUAL:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.feeAmount!).bold().end],
				[new Txt('TASA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.rate!).bold().end],
				[new Txt('PLAZO:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.term!).bold().end],
				[
					new Txt('DÉBITO AUTOMÁTICO:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.automaticDebit!).bold().end
				],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'open-CTS') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('TIPO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.operationType!).bold().end
				],
				[
					new Txt('NRO DE CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.newAccountNumber!).bold().end
				],
				[new Txt('MONEDA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.money!).bold().end],
				[new Txt('TASA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.rate!).bold().end],
				[new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else if (type === 'update-fastcash-config') {
			return new Table([
				[
					new Txt('TITULAR DE LA CUENTA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.headline!).bold().end
				],
				[
					new Txt('NRO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.numberOperation!).bold().end
				],
				[
					new Txt('TIPO DE OPERACIÓN:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.operationType!).bold().end
				],
				[new Txt('NRO DE TARJETA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.cardNumber).bold().end],
				[
					new Txt('CUENTA PRINCIPAL SELECCIONADA:').color(this._colorPacifico).bold().end,
					new Txt(this.dataPdf.newAccountNumber!).bold().end
				]
			])
				.widths(['30%', 'auto'])
				.layout('noBorders')
				.fontSize(12).end;
		} else {
			return null;
		}
	}

	private _getDataTransfer(): any[][] {
		const data: any[][] = [
			[
				new Txt('CUENTA DE ORIGEN:').color(this._colorPacifico).bold().end,
				new Txt(this.dataPdf.originAccount).bold().end
			]
		];

		if (this.dataPdf.mountSolesDolares) {
			data.push([
				new Txt('MONTO:').color(this._colorPacifico).bold().end,
				new Txt(this.dataPdf.mountSolesDolares).bold().end
			]);
		}

		data.push(
			[
				new Txt('CUENTA DE DESTINO:').color(this._colorPacifico).bold().end,
				new Txt(this.dataPdf.destinationAccount).bold().end
			],
			[new Txt('MONTO:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.amount).bold().end]
		);

		if (this.dataPdf.typeChange) {
			data.push([
				new Txt('TIPO DE CAMBIO:').color(this._colorPacifico).bold().end,
				new Txt(this.dataPdf.typeChange).bold().end
			]);
		}

		data.push([new Txt('FECHA:').color(this._colorPacifico).bold().end, new Txt(this.dataPdf.date).bold().end]);

		return data;
	}

	private _formEmail() {
		this.formGroup = this._formBuilder.group({
			email: [null, [Validators.required, Validators.email]]
		});
	}

	get emailField(): AbstractControl {
		return this.formGroup.get('email')!;
	}
}
